<div class="text-center mt-[20%]">
      <h1 class="text-2xl font-bold text-red-600">Oops! Something went wrong.</h1>
      <p class="text-gray-600 mt-4">Redirecting you to home...</p>
    </div>
